import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-i', 'IconLetterI', [
  ['path', { d: 'M12 4l0 16', key: 'svg-0' }],
]);
